export default {
  AllergiesFormFields__HEADER: "Allergies",
  AllergiesFormFields__PEANUT_ALLERGY: "Peanut or peanut dust allergy",
};
